import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class FilterCaseParamService {
  currentPage: number = 1;
  perPage: number = 20;
  assignees: number[] = [];
  owners: number[] = [];
  isDesc: boolean = true;
  invoice_id: number = 0; 
  search_query : string = '';
  status: string[] = ['All'];
  orderBy: string = 'createdAt';
  from: number =  Math.floor((Date.now() - 360 * 24 * 60 * 60 * 1000) / 1000); // Default from 360 days ago
  to: number =  Math.floor(Date.now() / 1000);

  currentDateRange: string = 'all';

  setFilterCase({
    currentPage = 1,
    perPage = 20,
    status = ['All'],
    owners = [], 
    assignees = [],
    invoice_id = 0,
    search_query = '',
    isDesc = true,
    orderBy = 'createdAt',
    from = Math.floor((Date.now() - 360 * 24 * 60 * 60 * 1000) / 1000),
    to = Math.floor(Date.now() / 1000)
  }: {
    currentPage?: number;
    perPage?: number;
    status?: string[];
    owners?: number[];
    assignees?: number[];
    orderBy?: string;
    invoice_id?: number;
    search_query?: string; 
    isDesc?: boolean;
    from?: number;
    to?: number;  
  }): void {
    this.currentPage = currentPage || 1;
    this.perPage = perPage || 20;
    this.status = status || ['All'];
    this.isDesc = isDesc  || true;
    this.orderBy = orderBy  || 'createdAt';
    this.owners = Array.isArray(owners) ? owners : [owners];
    this.assignees = Array.isArray(assignees) ? assignees : [assignees];
    this.invoice_id = invoice_id || 0;
    this.search_query = search_query || '';
    this.from = from  || Math.floor((Date.now() - 360 * 24 * 60 * 60 * 1000) / 1000);
    this.to = to  || Math.floor( Date.now() / 1000);
  }

  getFilterForAnalytics(): string {
   let result = ``;
    if (this.currentDateRange.length > 0 && this.currentDateRange !== 'all'){
      if (this.from) {
        result += `&from=${this.from}`;
      }

      if (this.to) {
        result += `&to=${this.to}`;
      }
    }
    if(this.assignees.length > 0) {
      this.assignees.forEach(id => {
        result += `&assignees=${id}`;
      })
    }

    if (this.owners.length > 0) {
       this.owners.forEach(id => {
        result += `&owners=${id}`;
      })
    }

    if (this.invoice_id > 0) {
      result += `&invoice_id=${this.invoice_id}`;
    }
    if (this.search_query) {
      result += `&search_query=${encodeURIComponent(this.search_query)}`;
    }
    
    return result;

  }

  getFilterForTickets(): string {
    let result = `page=${this.currentPage}&per_page=${this.perPage}&is_desc=${this.isDesc}&order_by=${this.orderBy}`;
    
     if(this.assignees.length > 0) {
      this.assignees.forEach(id => {
        result += `&assignees=${id}`;
      })
    }

    if (this.owners.length > 0) {
       this.owners.forEach(id => {
        result += `&owners=${id}`;
      })
    }
    

    if (this.invoice_id > 0) {
      result += `&invoice_id=${this.invoice_id}`;
    }

    if (this.search_query) {
      result += `&search_query=${encodeURIComponent(this.search_query)}`;
    }

    if (this.status.length > 0 && this.status[0] !== 'All') {
       this.status.forEach(s => {
        result += `&status=${s}`;
      })
    }

    if (this.currentDateRange.length > 0 && this.currentDateRange !== 'all'){
        result += `&from=${this.from}`;  
        if (this.currentDateRange === 'custom') {
          result += `&to=${this.to}`;
        } else {
          result += `&to=${ Math.floor( Date.now() / 1000)}`;
        }    
    }
    
    return result;
  }

  setCurrentDateRange(dateRange: string): void {
    this.currentDateRange = dateRange;
  }


  getCurrentDateRange(): string {
    return this.currentDateRange;
  }

  resetFilter(): void {
    this.currentPage = 1;
    this.perPage = 20;      
    this.orderBy = 'createdAt';
    this.isDesc = true;
  }

  getAssignees(): number[] {
    return this.assignees;
  }

  getOwners(): number[] {
    return this.owners;
  }

  getCurrentPage(): number {
    return this.currentPage;
  }

  getPerPage(): number {
    return this.perPage;
  }

  getStatus(): string[] {
    return this.status;
  }

  getIsDesc(): boolean {
    return this.isDesc;
  }

  getOrderBy(): string {
    return this.orderBy;
  }

  getInvoiceId(): number {
    return this.invoice_id;
  }

  getSearchQuery(): string {
    return this.search_query;
  }

  getFrom(): number {
    return this.from;
  }

  getTo(): number {
    return this.to;
  }

  getFilterCase(): any {
    return {
      currentPage: this.currentPage,
      perPage: this.perPage,
      status: this.status,
      owners: this.owners,
      assignees: this.assignees,
      isDesc: this.isDesc,
      orderBy: this.orderBy,
      invoice_id: this.invoice_id,
      search_query: this.search_query,
      from: this.from,
      to: this.to
    };
  }
  
}